import { User } from '@oaknorth/util-user';

export const isTrackingDisabled = () => {
  const storage = localStorage?.getItem('NO_TRACKING');
  return storage === 'true';
};

const NO_TRACKING_TENANT_IDS = [
  // AppSec tenant
  '52885de0-d40e-4dc8-abca-ae9287101e4b',
];

export const shouldTrack = (user: User) => {
  return (
    process.env.NODE_ENV === 'production' && !isTrackingDisabled() && !NO_TRACKING_TENANT_IDS.includes(user.tenantId)
  );
};
